export const availabilitySlots = {
  FETCH_AVAILABILITY_LOADING: 'FETCH_AVAILABILITY_LOADING',
  FETCH_AVAILABILITY_SUCCESS: 'FETCH_AVAILABILITY_SUCCESS',
  FETCH_SERVICE_PROVIDER_AVAILABILITY_SUCCESS: 'FETCH_SERVICE_PROVIDER_AVAILABILITY_SUCCESS',
  FETCH_AVAILABILITY_FAILURE: 'FETCH_AVAILABILITY_FAILURE',
  CLEAR_AVAILABILITYSLOTS: 'CLEAR_AVAILABILITYSLOTS',
}
